export default [
  {
    title: 'Dashboards',
    icon: 'HomeIcon',
    route: 'dashboard',
  },
]
